var EHDI = EHDI || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.SparkleEffect = function() {     
    EHDI.aka.Container.call(this);
    var _me = this;


    
    var _sparkleArmature = EHDI.DBoneFactory.createArmature("sparkle_armature");
    var _sparkleAnimationSprite = _sparkleArmature.getDisplay();
    _me.visible = false;
    _me.addChild(_sparkleAnimationSprite);

    var _appear = function(posX, posY)
    {
        _me.x = posX;
        _me.y = posY;
        _me.visible = true;        
        _sparkleArmature.animation.gotoAndPlay("fx_sparkle", -1, -1, 1);
    }
    this.appear = _appear.bind(this);

}
EHDI.components.SparkleEffect.prototype = Object.create(EHDI.aka.Container.prototype);